function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as uuidv4 } from 'uuid';
import { runEngine } from '../../../framework/src/RunEngine';
import { Message } from '../../../framework/src/Message';
import MessageEnum, { getName } from '../../../framework/src/Messages/MessageEnum';
export default class PrivacyPolicyAdapter {
  constructor() {
    _defineProperty(this, "convert", from => {
      const to = new Message(getName(MessageEnum.NavigationMessage));
      to.addData(getName(MessageEnum.NavigationTargetMessage), 'InfoPage');
      to.addData(getName(MessageEnum.NavigationPropsMessage), from.getData(getName(MessageEnum.NavigationPropsMessage)));
      const raiseMessage = new Message(getName(MessageEnum.NavigationPayLoadMessage));
      raiseMessage.addData(getName(MessageEnum.InfoPageTitleMessage), 'Privacy Policy');
      raiseMessage.addData(getName(MessageEnum.InfoPageBodyMessage), 'Feature Comming Soon..');
      raiseMessage.addData(getName(MessageEnum.InfoPageButtonTextMessage), 'Home');
      const buttonNavigationMessage = new Message(getName(MessageEnum.NavigationHomeScreenMessage));
      buttonNavigationMessage.addData(getName(MessageEnum.NavigationPropsMessage), from.getData(getName(MessageEnum.NavigationPropsMessage)));
      raiseMessage.addData(getName(MessageEnum.InfoPageNavigationScreenMessage), buttonNavigationMessage);
      to.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
      to.addData(getName(MessageEnum.NavigationScreenNameMessage), 'Privacy Policy');
      return to;
    });
    const blockId = uuidv4();
    this.send = message => runEngine.sendMessage(blockId, message);
    runEngine.attachBuildingBlock(this, [getName(MessageEnum.NavigationPrivacyPolicyMessage)]);
  }
  receive(from, message) {
    this.send(this.convert(message));
  }
}